// src/components/Header.js
import React, { useState, useEffect } from "react";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { useAuth } from "../AuthContext";
import { Link, useLocation } from "react-router-dom"; // Add useLocation

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { user } = useAuth();
  const location = useLocation(); // Get current location

  // Add scroll event listener only if on home page
  useEffect(() => {
    if (location.pathname === "/") {
      const handleScroll = () => {
        const scrollPosition = window.scrollY;
        setIsScrolled(scrollPosition > 0);
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    } else {
      setIsScrolled(false); // Reset scroll state on other pages
    }
  }, [location.pathname]); // Re-run effect when path changes

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleSignOut = async () => {
    await signOut(auth);
  };

  // Apply 'scrolled' class only on home page when scrolled
  const headerClass = location.pathname === "/"
    ? (isScrolled ? 'scrolled' : '')
    : 'default-background'; // Add a class for non-home pages

  return (
    <header className={headerClass}>
      <div className="logo">MATHS GEM SEYCHELLES</div>
      <button
        className="hamburger"
        onClick={toggleMenu}
        aria-label={isOpen ? "Close menu" : "Open menu"}
        aria-expanded={isOpen}
      >
        {isOpen ? "✖" : "☰"}
      </button>
      <nav className={isOpen ? "nav-mobile open" : "nav-mobile"}>
        <Link to="/" onClick={toggleMenu}>
          Home
        </Link>

        {user ? (
          <>
            <Link to="/dashboard" onClick={toggleMenu}>
              My Dashboard
            </Link>
            <Link to="/profileDashboard" onClick={toggleMenu}>
              My Profile
            </Link>
            {user.role === 'admin' && (
              <Link to="/admin" onClick={toggleMenu}>
                Admin
              </Link>
            )}
            <Link to="/contactus" onClick={toggleMenu}>
              Contact Us
            </Link>
            <button className="login-btn" onClick={handleSignOut}>
              Sign Out
            </button>
          </>
        ) : (
          <>
           <Link to="/pricing" onClick={toggleMenu}>
              Pricing
            </Link>
            <Link to="/contactus" onClick={toggleMenu}>
              Contact Us
            </Link>
            <Link to="/sign-in" onClick={toggleMenu}>
              Sign In
            </Link>
            <Link to="/sign-up" onClick={toggleMenu}>
              Register
            </Link>
          </>
        )}
      </nav>
    </header>
  );
};

export default Header;